export const LoadingMoto = () => {
  return (
    <div className="fixed inset-0 bg-white z-50" />
  );
};